<div
  style="height: 100vh; width: 100vw; z-index: 999999"
  class="backdrop-blur-md pt-1 flex flex-col justify-stretch items-start relative"
>
  <div class="flex flex-row w-full bg-black">
    <div class="flex w-full justify-center items-start">
      <h1
        class="text-[#ff4d06] text-lg md:text-xl text-center title-font font-medium mb-1"
      >
        {{ product!.label! }}
      </h1>
    </div>
    <div class="flex flex-col justify-center items-start w-52">
      <div
        class="flex flex-row justify-end items-start w-full pr-2"
        style="z-index: 99999"
      >
        <button
          (click)="close()"
          aria-label="close window"
          class="border border-gray-600 justify-center flex text-white font-semibold py-2 px-4 hover:border-white hover:text-black hover:bg-[#ff4d067c] rounded-lg"
        >
          <span>Close </span> &nbsp; &#10006;
        </button>
      </div>
    </div>
  </div>
  <div
    style="
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.9);
      padding: 0;
      z-index: 1000000;
    "
    class="flex flex-row pb-3 w-full"
  >
    <div class="flex-1 p-4 flex flex-row gap-2 justify-center items-center">
      <button
        mat-mini-fab
        color="warn"
        [disabled]="qty.value === 1"
        (click)="reduce()"
        aria-label="reduce quantity"
      >
        <img
          src="../../../assets/graphics/remove_24dp_FILL1_wght400_GRAD0_opsz24.svg"
        />
      </button>
      <input
        readonly
        [formControl]="qty"
        class="appearance-none text-center text-lg font-bold block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:border-orange-500"
        id="qty"
        type="number"
        min="1"
        max="100"
      />
      <button
        mat-mini-fab
        color="warn"
        (click)="add()"
        [disabled]="qty.value === 100"
        aria-label="increase quantity"
      >
        <img
          src="../../../assets/graphics/add_24dp_FILL1_wght400_GRAD0_opsz24.svg"
        />
      </button>
    </div>
    <div class="flex-1 p-4">
      <button
      (click)="addToCart()"
      aria-label="add to Cart"
      class="text-white bg-gradient-to-r from-orange-500 to-red-500 border-0 py-3 px-4 md:py-4 md:px-6 focus:outline-none hover:from-orange-600 hover:to-red-600 rounded-lg font-bold text-md md:text-xl flex w-full items-center justify-center gap-2 transition-all duration-300 shadow-lg"
    >
      <span>ADD TO CART</span>
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.1 5H19M7 13v8a2 2 0 002 2h10a2 2 0 002-2v-3"></path>
      </svg>
    </button>
    </div>
  </div>

  <div class="flex flex-row justify-center items-center w-full">
    <div
      class="w-full flex flex-col items-center justify-center"
      style="overflow-y: auto"
    >
      <div
        class="aspect-square backdrop-blur-sm relative self-center w-full md:w-[500px]"
      >
        <div
          class="relative w-full h-full image_card rounded-xl items-center justify-center flex-row flex"
        >
          <img
            [src]="getHost() + '/' + product.icon"
            class="rounded-xl shadow aspect-square contain"
            [alt]="product!.label!"
            style="position: absolute; object-fit: contain"
          />
        </div>
      </div>

      <p class="text-md title-font text-white">
        {{ product.warranty | uppercase }} WARRANTY
      </p>

      <div class="flex flex-col">
        <div class="pb-4">
          <div
            *ngIf="product.availability === 'PRE_ORDER'"
            class="bg-yellow-300 text-red-800 w-full text-md rounded-md font-medium me-2 px-2.5 py-0.5 text-center"
          >
            <span>Early Reservation Only</span>
          </div>

          <div
            *ngIf="product.availability === 'IN_STOCK'"
            class="bg-yellow-300 text-red-800 w-full text-md rounded-md font-medium me-2 px-2.5 py-0.5 text-center"
          >
            <span>In Supply</span>
          </div>

          <div
            *ngIf="product.availability === 'OUT_OF_STOCK'"
            class="bg-red-800 text-yellow-300 w-full text-md rounded-md font-medium me-2 px-2.5 py-0.5 text-center"
          >
            <span>Sold Out</span>
          </div>
        </div>

        <div class="flex flex-col">
          <div class="flex flex-col w-full bg-[#ff4d06] rounded-xl p-4">
            <div
              class="bg-white rounded-lg justify-center content-center flex flex-row p-4"
            >
              <div class="flex flex-row justify-center">
                <h3
                  class="flex title-font font-medium !text-center text-3xl text-black black-ops_one-regular"
                  style="text-align: center !important; width: 100%"
                >
                  {{ product.newPrice | currency : "Rs. " : "Rs." : "1.0-0" }}
                </h3>
              </div>
            </div>

            <div *ngIf="product.discounted">
              <div class="flex flex-col justify-center items-center pt-2">
                <span class="text-center text-white font-bold text-3xl">
                  {{ "Exclusive Deal" | uppercase }}
                </span>
                <span
                  class="title-font text-xl text-black prevP mt-2 black-ops_one-regular !line-through"
                  >{{
                    product.previousPrice | currency : "Rs." : "Rs." : "1.0-0"
                  }}</span
                >
              </div>
            </div>
          </div>

          <!-- <div class="flex flex-row justify-center p-4 absolute top-0 right-0" style="z-index: 99999">
          <button
            (click)="close()"
            aria-label="close window"
            class="border border-gray-600 justify-center flex text-white font-semibold py-2 px-4 hover:border-white hover:text-black hover:bg-[#ff4d067c] rounded-lg"
          >
            <span>Close </span> &nbsp; &#10006;

          </button>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
